module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'subMenuItem': true, 'close-panel': !_vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.labelId && _vm.labelId !== '') ? _c('span', [_vm._v(_vm._s(_vm.$t(_vm.labelId)))]) : _c('span', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61449b2f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61449b2f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/MobileMenuComponents/MobileMenuSectionListItem.vue
// module id = 2434
// module chunks = 2